import $ from 'cash-dom'
import retina from 'retinajs'
import Pushbar from './components/pushbar'
import Tooltip from 'tooltip.js'
import Flickity from 'flickity-fade'

document.addEventListener('DOMContentLoaded', function() {

    /**
     * Dropdown menus
     */
    $('.nav-main > li').has('.dropdown').on('mouseover', function () {
        $(this).children('.dropdown').addClass('is-visible')
    }).on('mouseout', function () {
        $(this).children('.dropdown').removeClass('is-visible')
    })

    /**
     * Global retina image swaps
     */
    retina()

    /**
     * Mobile nav
     */
    new Pushbar({
        // blur: true,
        overlay: true,
    })

    /**
     * Hero slider
     */
    const heroSlider = document.querySelector('[data-hero-slider]')
    if (heroSlider) {
        new Flickity(heroSlider, {
            autoPlay: 5000,
            fade: true,
            pauseAutoPlayOnHover: false,
            draggable: '>1',
            pageDots: true,
            prevNextButtons: false,
            wrapAround: true,
            cellSelector: 'article'
        })
    }

    /**
     * Tooltip
     */

    const $tooltipTrigger = $('[data-tooltip]')
    $tooltipTrigger.each(function(index, element) {
        const placement = 
        new Tooltip(element, {
            title: element.getAttribute('data-tooltip'),
            trigger: 'hover',
            placement: element.getAttribute('data-tooltip-placement')
        })
    })

})


// WEBPACK FOOTER //
// ./assets/js/main.js